import { render } from "./MBaseModal.vue?vue&type=template&id=be025f30&scoped=true&ts=true"
import script from "./MBaseModal.vue?vue&type=script&lang=ts"
export * from "./MBaseModal.vue?vue&type=script&lang=ts"

import "./MBaseModal.vue?vue&type=style&index=0&id=be025f30&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be025f30"]])

export default __exports__